import Container from '@/components/Container';
import useRegister from './useRegister';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import DialogTermsAndServices from '@/components/DialogTermsAndServices';
import FieldError from '@/components/FieldError';

export const RegistrationForm = () => {
  const { formRef, handleSubmit, registerPage, register, errors, isLoading } = useRegister();
  const [open, setOpen] = useState<boolean | null>(null);

  if (!registerPage) return null;

  return (
    <Container className="h-full items-center justify-center">
      <div
        className="col-span-10 grid max-h-[90vh] grid-cols-1 overflow-auto rounded-2xl bg-white p-8 lg:col-start-2 lg:grid-cols-[1fr_1fr]"
        style={{ boxShadow: '0px 0px 20px 0px #86AAD5' }}>
        <div className=" flex flex-col items-center justify-center lg:mr-14">
          <h1 className="mb-4 text-sh-md">{registerPage?.welcomeToTItle}</h1>
          <img
            className="mb-sh-15 h-auto w-[56%]"
            src={registerPage?.logo.data?.attributes?.url}
            alt={registerPage?.logo.data?.attributes?.alternativeText || 'Logo'}
          />
          <p className="mb-5 text-center !text-sh-18-24 leading-9 tracking-tight text-gray-900">
            {registerPage?.description}
          </p>

          <img
            className="mb-11 h-auto w-full"
            width={40}
            height={40}
            src={registerPage?.image.data?.attributes?.url}
            alt={registerPage?.image.data?.attributes?.alternativeText || 'Logo'}
          />
        </div>
        <div>
          {/* <h2 className="mb-sh-15 text-sh-xs font-medium leading-9 tracking-tight text-gray-900">
            {registerPage?.registerTitle}
          </h2>
 */}

          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="mb-5 grid w-full grid-cols-1 md:grid-cols-2 md:gap-4">
              <div>
                <Label>
                  <p className="mb-2 text-sh-xs">{registerPage?.schoolCode}</p>
                </Label>
                <Input placeholder={registerPage?.schoolCode} type="schoolCode" {...register('schoolCode')} />
                <FieldError message={errors?.schoolCode?.message} />
              </div>
              <div>&nbsp;</div>
            </div>

            <div className="mb-5 grid w-full grid-cols-1 md:grid-cols-2 md:gap-4">
              <div>
                <Label>
                  <p className="mb-2 text-sh-xs">{registerPage?.yourFirstName}</p>
                </Label>
                <Input placeholder={registerPage?.yourFirstName} {...register('forename')} />
                <FieldError message={errors?.forename?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 text-sh-xs">{registerPage?.yourLastName}</p>
                </Label>
                <Input placeholder={registerPage?.yourLastName} {...register('surname')} />
                <FieldError message={errors?.surname?.message} />
              </div>
            </div>

            <div className="mb-5 w-full">
              <Label>
                <p className="mb-2 text-sh-xs">{registerPage?.yourEmail}</p>
              </Label>
              <Input placeholder={registerPage?.yourEmail} type="email" {...register('email')} />
              <FieldError message={errors?.email?.message} />
            </div>

            <div className="mb-5 grid w-full grid-cols-1 md:grid-cols-2 md:gap-4">
              <div>
                <Label>
                  <p className="mb-2 text-sh-xs">{registerPage?.choosePassword}</p>
                </Label>
                <Input placeholder={registerPage?.choosePassword} type="password" {...register('password')} />
                <FieldError message={errors?.password?.message} />
              </div>
              <div>
                <Label>
                  <p className="mb-2 text-sh-xs">{registerPage?.repeatYourPassword}</p>
                </Label>
                <Input
                  placeholder={registerPage?.repeatYourPassword}
                  type="password"
                  {...register('confirmPassword')}
                />
                <FieldError message={errors?.confirmPassword?.message} />
              </div>
            </div>

            <div className="mb-2 w-full">
              <Label className="mb-2 flex items-center">
                <input type="checkbox" {...register('termsAndConditions')} />
                <p className="ml-2 text-sh-xs">
                  I agree to the{' '}
                  <button
                    type="button"
                    onClick={() => {
                      setOpen(true);
                    }}
                    className="font-bold text-primary-600 underline">
                    terms and conditions
                  </button>
                </p>
              </Label>
              <FieldError message={errors?.termsAndConditions?.message} />
            </div>

            <div className="mb-5 w-full">
              <Label className="mb-2 flex items-center">
                <p className="text-sh-xs">
                  Already registered?{' '}
                  <Link to="/login" className="font-bold text-primary-600 underline">
                    Sign in
                  </Link>
                </p>
              </Label>
            </div>

            <Button type="submit" theme="solid" className=" mb-4" loading={isLoading}>
              {registerPage?.createYourAccountCta}
            </Button>
          </form>
        </div>
      </div>
      <DialogTermsAndServices open={open || false} setOpen={setOpen} />
    </Container>
  );
};

export default RegistrationForm;
